/* Small progressive enhancements; real commerce remains Shopify's. */
(function(){
 'use strict';
 function mount(){
  var header=document.querySelector('[data-gg-ex-header]');
  if(!header||header.dataset.bound)return;header.dataset.bound='true';
  var disclosures=Array.from(header.querySelectorAll('[data-gg-ex-disclosure]'));
  function close(except,returnFocus){disclosures.forEach(function(d){if(d!==except&&d.open){d.open=false;if(returnFocus)d.querySelector('summary').focus();}});}
  disclosures.forEach(function(d){d.addEventListener('toggle',function(){if(d.open)close(d,false);});});
  document.addEventListener('click',function(e){if(!header.contains(e.target))close(null,false);else if(e.target.closest('a'))close(null,false);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close(null,true);});
  // Safari leaves clicked links unfocused. A null relatedTarget must not close
  // the menu between pointerdown and pointerup; outside clicks close it above.
  header.addEventListener('focusout',function(e){if(e.relatedTarget&&!header.contains(e.relatedTarget))close(null,false);});
  function measure(){document.documentElement.style.setProperty('--gg-concept-header-height',header.offsetHeight+'px');document.documentElement.style.setProperty('--header--height',header.offsetHeight+'px');}
  measure();if(window.ResizeObserver)new ResizeObserver(measure).observe(header);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
 document.addEventListener('shopify:section:load',mount);
})();
